export const times = [
  {
    label: "",
    value: "",
  },
  {
    label: "5 دقیقه",
    value: "05",
  },
  {
    label: "10 دقیقه",
    value: "10",
  },
  {
    label: "20 دقیقه",
    value: "20",
  },
  {
    label: "25 دقیقه",
    value: "25",
  },
  {
    label: "30 دقیقه",
    value: "30",
  },
  {
    label: "35 دقیقه",
    value: "35",
  },
  {
    label: "40 دقیقه",
    value: "40",
  },
  {
    label: "45 دقیقه",
    value: "45",
  },
  {
    label: "50 دقیقه",
    value: "50",
  },
  {
    label: "55 دقیقه",
    value: "55",
  },
  {
    label: "1 ساعت",
    value: "60",
  },
  {
    label: "1ساعت  5دقیقه",
    value: "65",
  },
  {
    label: "1ساعت  10دقیقه",
    value: "70",
  },
  {
    label: "1ساعت  15دقیقه",
    value: "75",
  },
  {
    label: "1ساعت  20دقیقه",
    value: "80",
  },
  {
    label: "1ساعت  25دقیقه",
    value: "85",
  },
  {
    label: "1ساعت  30دقیقه",
    value: "90",
  },
  {
    label: "1ساعت  35دقیقه",
    value: "95",
  },
  {
    label: "1ساعت  40دقیقه",
    value: "100",
  },
  {
    label: "1ساعت  45دقیقه",
    value: "105",
  },
  {
    label: "1ساعت  50دقیقه",
    value: "110",
  },
  {
    label: "1ساعت  55دقیقه",
    value: "115",
  },
  {
    label: "2ساعت",
    value: "120",
  },
  {
    label: "2ساعت  5دقیقه",
    value: "125",
  },
  {
    label: "2ساعت  10دقیقه",
    value: "130",
  },
  {
    label: "2ساعت  15دقیقه",
    value: "135",
  },
  {
    label: "2ساعت  20دقیقه",
    value: "140",
  },
  {
    label: "2ساعت  25دقیقه",
    value: "145",
  },
  {
    label: "2ساعت  30دقیقه",
    value: "150",
  },
  {
    label: "2ساعت  35دقیقه",
    value: "155",
  },
  {
    label: "2ساعت  40دقیقه",
    value: "160",
  },
  {
    label: "2ساعت  45دقیقه",
    value: "165",
  },
  {
    label: "2ساعت  50دقیقه",
    value: "170",
  },
  {
    label: "2ساعت  55دقیقه",
    value: "175",
  },
  {
    label: "3ساعت",
    value: "180",
  },
  {
    label: "3ساعت  5دقیقه",
    value: "185",
  },
  {
    label: "3ساعت  10دقیقه",
    value: "190",
  },
  {
    label: "3ساعت  15دقیقه",
    value: "195",
  },
  {
    label: "3ساعت  20دقیقه",
    value: "200",
  },
  {
    label: "3ساعت  25دقیقه",
    value: "205",
  },
  {
    label: "3ساعت  30دقیقه",
    value: "210",
  },
  {
    label: "3ساعت  35دقیقه",
    value: "215",
  },
  {
    label: "3ساعت  40دقیقه",
    value: "220",
  },
  {
    label: "3ساعت  45دقیقه",
    value: "225",
  },
  {
    label: "3ساعت  50دقیقه",
    value: "230",
  },
  {
    label: "3ساعت  55دقیقه",
    value: "235",
  },
  {
    label: "4ساعت",
    value: "240",
  },
  {
    label: "4ساعت  5دقیقه",
    value: "245",
  },
  {
    label: "4ساعت  10دقیقه",
    value: "250",
  },
  {
    label: "4ساعت  15دقیقه",
    value: "255",
  },
  {
    label: "4ساعت  20دقیقه",
    value: "260",
  },
  {
    label: "4ساعت  25دقیقه",
    value: "265",
  },
  {
    label: "4ساعت  30دقیقه",
    value: "270",
  },
  {
    label: "4ساعت  35دقیقه",
    value: "275",
  },
  {
    label: "4ساعت  40دقیقه",
    value: "280",
  },
  {
    label: "4ساعت  45دقیقه",
    value: "285",
  },
  {
    label: "4ساعت  50دقیقه",
    value: "290",
  },
  {
    label: "4ساعت  55دقیقه",
    value: "295",
  },
  {
    label: "5ساعت",
    value: "300",
  },
  {
    label: "5ساعت  5دقیقه",
    value: "305",
  },
  {
    label: "5ساعت  10دقیقه",
    value: "310",
  },
  {
    label: "5ساعت  15دقیقه",
    value: "315",
  },
  {
    label: "5ساعت  20دقیقه",
    value: "320",
  },
  {
    label: "5ساعت  25دقیقه",
    value: "325",
  },
  {
    label: "5ساعت  30دقیقه",
    value: "330",
  },
  {
    label: "5ساعت  35دقیقه",
    value: "335",
  },
  {
    label: "5ساعت  40دقیقه",
    value: "340",
  },
  {
    label: "5ساعت  45دقیقه",
    value: "345",
  },
  {
    label: "5ساعت  50دقیقه",
    value: "350",
  },
  {
    label: "5ساعت  55دقیقه",
    value: "355",
  },
  {
    label: "6ساعت",
    value: "360",
  },
];
